import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "merge-theme-modal__form-body" }
const _hoisted_2 = { class: "modal-field__row" }
const _hoisted_3 = { class: "modal-field modal-field--inline" }
const _hoisted_4 = { class: "modal-field__label" }
const _hoisted_5 = { class: "merge-theme-modal__themes" }
const _hoisted_6 = { class: "modal-field__label" }
const _hoisted_7 = { class: "merge-theme-modal__themes-list" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "confirm-modal-body" }
const _hoisted_10 = { class: "merge-theme-modal__themes-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Modal, { onClose: _ctx.closeModal }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("titles.merge")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("form", {
          class: "merge-theme-modal__form",
          id: "merge-themes-form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showConfirmModal && _ctx.showConfirmModal(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("labels.mergeThemeName")) + ": ", 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newThemeName) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.newThemeName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("labels.themesList")), 1),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.themes, (theme) => {
                  return (_openBlock(), _createElementBlock("label", {
                    class: "modal-field modal-field--checkbox",
                    key: theme.id
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: theme.id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedThemeIds) = $event))
                    }, null, 8, _hoisted_8), [
                      [_vModelCheckbox, _ctx.selectedThemeIds]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(theme.name), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ], 32)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_BasicButton, {
          class: "mutate-button",
          type: "submit",
          form: `merge-themes-form`,
          disabled: !_ctx.newThemeName || _ctx.selectedThemeIds.length < 2
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("buttons.merge")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["onClose"]),
    (_ctx.isConfirmModalVisible)
      ? (_openBlock(), _createBlock(_component_ConfirmModal, {
          key: 0,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeConfirmModal())),
          onNo: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeConfirmModal())),
          onYes: _ctx.runMergeThemes,
          question: _ctx.t('titles.mergeConfirmation')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("validateMerge")), 1),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedThemes, (theme) => {
                  return (_openBlock(), _createElementBlock("label", {
                    class: "modal-field modal-field--checkbox",
                    key: theme.id
                  }, _toDisplayString(theme.name), 1))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["onYes", "question"]))
      : _createCommentVNode("", true)
  ], 64))
}